import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { setCurrentInjector } from '@spa/common/injector-context';
import { Environment, environment } from '@spa/environment';
import { BootstrapModule } from './app/bootstrap/bootstrap.module';
import { PostBootstrapService } from './app/bootstrap/post-bootstrap.service';

import 'hammerjs';

async function bootstrapNgHost(env: Environment) {
	if (env.production) {
		enableProdMode();
	} else {
		setDevelopmentGlobalHelpers();
	}
	const ngModuleRef = await platformBrowserDynamic().bootstrapModule(BootstrapModule, {
		ngZoneEventCoalescing: true,
	});
	setCurrentInjector(ngModuleRef.injector);
	const zone = ngModuleRef.injector.get(NgZone);
	zone.runTask(() => {
		const postBootstrapService = ngModuleRef.injector.get(PostBootstrapService);
		postBootstrapService.run();
	});
	return ngModuleRef;
}

function startUpApplication(env: Environment) {
	bootstrapNgHost(env).catch(err => console.error(err));
}

function setDevelopmentGlobalHelpers() {
	const ng = window['ng'] || {};
	if (ng) {
		ng.get = domEl => {
			if (ng.probe) {
				// view engine
				const debugEl = ng.probe(domEl);
				return debugEl && debugEl.componentInstance;
			} else if (ng.getComponent) {
				// ivy
				return ng.getComponent(domEl);
			}
		};
	}
}

Object.defineProperty(window, 'hammer', {
	get() {
		return window.Hammer;
	},
});

startUpApplication(environment);
